import { api } from './client';

export async function getSettings() {
  return api.get('/settings');
}

export async function updateSettings(data) {
  return api.patch('/settings', data);
}

export async function updateChildSettings(childId, data) {
  return api.patch(`/settings/child/${childId}`, data);
}

export async function deleteAccount() {
  return api.delete('/settings/account');
}
